import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
  selector: "d2d-client-auth-layout",
  imports: [RouterModule],
  templateUrl: "./client-auth-layout.component.html",
})
export class ClientAuthLayoutComponent {}
